// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { INotificationPropertiesInfoDto } from './INotificationPropertiesInfoDto';
import {
    INotificationPropertiesInfoDtoFromJSON,
    INotificationPropertiesInfoDtoFromJSONTyped,
    INotificationPropertiesInfoDtoToJSON,
    INotificationPropertiesInfoDtoToJSONTyped,
} from './INotificationPropertiesInfoDto';
import type { IPropertyChangeDto } from './IPropertyChangeDto';
import {
    IPropertyChangeDtoFromJSON,
    IPropertyChangeDtoFromJSONTyped,
    IPropertyChangeDtoToJSON,
    IPropertyChangeDtoToJSONTyped,
} from './IPropertyChangeDto';
import type { IOrganizationPropertyInfoDto } from './IOrganizationPropertyInfoDto';
import {
    IOrganizationPropertyInfoDtoFromJSON,
    IOrganizationPropertyInfoDtoFromJSONTyped,
    IOrganizationPropertyInfoDtoToJSON,
    IOrganizationPropertyInfoDtoToJSONTyped,
} from './IOrganizationPropertyInfoDto';
import type { IOrganizationPhoneInfoDto } from './IOrganizationPhoneInfoDto';
import {
    IOrganizationPhoneInfoDtoFromJSON,
    IOrganizationPhoneInfoDtoFromJSONTyped,
    IOrganizationPhoneInfoDtoToJSON,
    IOrganizationPhoneInfoDtoToJSONTyped,
} from './IOrganizationPhoneInfoDto';
import type { IOverridablePropertiesInfoDto } from './IOverridablePropertiesInfoDto';
import {
    IOverridablePropertiesInfoDtoFromJSON,
    IOverridablePropertiesInfoDtoFromJSONTyped,
    IOverridablePropertiesInfoDtoToJSON,
    IOverridablePropertiesInfoDtoToJSONTyped,
} from './IOverridablePropertiesInfoDto';
import type { IOrganizationAddressInfoDto } from './IOrganizationAddressInfoDto';
import {
    IOrganizationAddressInfoDtoFromJSON,
    IOrganizationAddressInfoDtoFromJSONTyped,
    IOrganizationAddressInfoDtoToJSON,
    IOrganizationAddressInfoDtoToJSONTyped,
} from './IOrganizationAddressInfoDto';
import type { IOrganizationNoteDto } from './IOrganizationNoteDto';
import {
    IOrganizationNoteDtoFromJSON,
    IOrganizationNoteDtoFromJSONTyped,
    IOrganizationNoteDtoToJSON,
    IOrganizationNoteDtoToJSONTyped,
} from './IOrganizationNoteDto';

/**
 * 
 * @export
 * @interface IOrganizationInfoDto
 */
export interface IOrganizationInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IOrganizationInfoDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationInfoDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationInfoDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationInfoDto
     */
    short_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationInfoDto
     */
    parent_id: number;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationInfoDto
     */
    type: IOrganizationInfoDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationInfoDto
     */
    organization_status_type?: IOrganizationInfoDtoOrganizationStatusTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IOrganizationInfoDto
     */
    organization_status_valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IOrganizationInfoDto
     */
    created_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationInfoDto
     */
    business_entity_type?: IOrganizationInfoDtoBusinessEntityTypeEnum;
    /**
     * 
     * @type {Set<IOrganizationAddressInfoDto>}
     * @memberof IOrganizationInfoDto
     */
    addresses: Set<IOrganizationAddressInfoDto>;
    /**
     * 
     * @type {IOrganizationPhoneInfoDto}
     * @memberof IOrganizationInfoDto
     */
    organization_phone?: IOrganizationPhoneInfoDto;
    /**
     * 
     * @type {IOverridablePropertiesInfoDto}
     * @memberof IOrganizationInfoDto
     */
    overridable_properties?: IOverridablePropertiesInfoDto;
    /**
     * 
     * @type {INotificationPropertiesInfoDto}
     * @memberof IOrganizationInfoDto
     */
    notification_properties?: INotificationPropertiesInfoDto;
    /**
     * 
     * @type {IOrganizationPropertyInfoDto}
     * @memberof IOrganizationInfoDto
     */
    normal_properties?: IOrganizationPropertyInfoDto;
    /**
     * 
     * @type {IOrganizationNoteDto}
     * @memberof IOrganizationInfoDto
     */
    note?: IOrganizationNoteDto;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationInfoDto
     */
    organization_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationInfoDto
     */
    partner_external_identifier?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationInfoDto
     */
    activation_started?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationInfoDto
     */
    partner_name?: string;
    /**
     * 
     * @type {Date}
     * @memberof IOrganizationInfoDto
     */
    termination_date?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationInfoDto
     */
    is_locked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationInfoDto
     */
    is_limited_features_during_termination_in_progress?: boolean;
    /**
     * 
     * @type {Array<IPropertyChangeDto>}
     * @memberof IOrganizationInfoDto
     */
    modified_overridable_properties?: Array<IPropertyChangeDto>;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationInfoDto
     */
    has_child_organizations?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationInfoDto
     */
    custodian_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationInfoDto
     */
    custodian_agreement_url?: string;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationInfoDto
     */
    interest_template_id?: number;
}

/**
* @export
* @enum {string}
*/
export enum IOrganizationInfoDtoTypeEnum {
    SYSTEM = 'SYSTEM',
    PARTNER = 'PARTNER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    COMPANY = 'COMPANY',
    SUBSIDIARY = 'SUBSIDIARY',
    SUBGROUP = 'SUBGROUP'
}
/**
* @export
* @enum {string}
*/
export enum IOrganizationInfoDtoOrganizationStatusTypeEnum {
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    TERMINATED = 'TERMINATED',
    ACTIVATION_FAILED = 'ACTIVATION_FAILED',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    EXPRESS_SETUP = 'EXPRESS_SETUP',
    ABANDONED = 'ABANDONED',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}
/**
* @export
* @enum {string}
*/
export enum IOrganizationInfoDtoBusinessEntityTypeEnum {
    C_CORPORATION = 'C_CORPORATION',
    S_CORPORATION = 'S_CORPORATION',
    LIMITED_LIABILITY_CORP = 'LIMITED_LIABILITY_CORP',
    GOVERNMENT_ENTITY = 'GOVERNMENT_ENTITY',
    NON_PROFIT = 'NON_PROFIT',
    PARTNERSHIP = 'PARTNERSHIP',
    SOLO_PROPRIETORSHIP = 'SOLO_PROPRIETORSHIP'
}


/**
 * Check if a given object implements the IOrganizationInfoDto interface.
 */
export function instanceOfIOrganizationInfoDto(value: object): value is IOrganizationInfoDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('parent_id' in value) || value['parent_id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('addresses' in value) || value['addresses'] === undefined) return false;
    return true;
}

export function IOrganizationInfoDtoFromJSON(json: any): IOrganizationInfoDto {
    return IOrganizationInfoDtoFromJSONTyped(json, false);
}

export function IOrganizationInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrganizationInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'name': json['name'],
        'short_name': json['short_name'] == null ? undefined : json['short_name'],
        'parent_id': json['parent_id'],
        'type': json['type'],
        'organization_status_type': json['organization_status_type'] == null ? undefined : json['organization_status_type'],
        'organization_status_valid_from': json['organization_status_valid_from'] == null ? undefined : (new Date(json['organization_status_valid_from'])),
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'business_entity_type': json['business_entity_type'] == null ? undefined : json['business_entity_type'],
        'addresses': (new Set((json['addresses'] as Array<any>).map(IOrganizationAddressInfoDtoFromJSON))),
        'organization_phone': json['organization_phone'] == null ? undefined : IOrganizationPhoneInfoDtoFromJSON(json['organization_phone']),
        'overridable_properties': json['overridable_properties'] == null ? undefined : IOverridablePropertiesInfoDtoFromJSON(json['overridable_properties']),
        'notification_properties': json['notification_properties'] == null ? undefined : INotificationPropertiesInfoDtoFromJSON(json['notification_properties']),
        'normal_properties': json['normal_properties'] == null ? undefined : IOrganizationPropertyInfoDtoFromJSON(json['normal_properties']),
        'note': json['note'] == null ? undefined : IOrganizationNoteDtoFromJSON(json['note']),
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'partner_external_identifier': json['partner_external_identifier'] == null ? undefined : json['partner_external_identifier'],
        'activation_started': json['activation_started'] == null ? undefined : json['activation_started'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'termination_date': json['termination_date'] == null ? undefined : (new Date(json['termination_date'])),
        'is_locked': json['is_locked'] == null ? undefined : json['is_locked'],
        'is_limited_features_during_termination_in_progress': json['is_limited_features_during_termination_in_progress'] == null ? undefined : json['is_limited_features_during_termination_in_progress'],
        'modified_overridable_properties': json['modified_overridable_properties'] == null ? undefined : ((json['modified_overridable_properties'] as Array<any>).map(IPropertyChangeDtoFromJSON)),
        'has_child_organizations': json['has_child_organizations'] == null ? undefined : json['has_child_organizations'],
        'custodian_name': json['custodian_name'] == null ? undefined : json['custodian_name'],
        'custodian_agreement_url': json['custodian_agreement_url'] == null ? undefined : json['custodian_agreement_url'],
        'interest_template_id': json['interest_template_id'] == null ? undefined : json['interest_template_id'],
    };
}

export function IOrganizationInfoDtoToJSON(json: any): IOrganizationInfoDto {
    return IOrganizationInfoDtoToJSONTyped(json, false);
}

export function IOrganizationInfoDtoToJSONTyped(value?: IOrganizationInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'external_identifier': value['external_identifier'],
        'name': value['name'],
        'short_name': value['short_name'],
        'parent_id': value['parent_id'],
        'type': value['type'],
        'organization_status_type': value['organization_status_type'],
        'organization_status_valid_from': value['organization_status_valid_from'] == null ? undefined : ((value['organization_status_valid_from']).toISOString()),
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'business_entity_type': value['business_entity_type'],
        'addresses': (Array.from(value['addresses'] as Set<any>).map(IOrganizationAddressInfoDtoToJSON)),
        'organization_phone': IOrganizationPhoneInfoDtoToJSON(value['organization_phone']),
        'overridable_properties': IOverridablePropertiesInfoDtoToJSON(value['overridable_properties']),
        'notification_properties': INotificationPropertiesInfoDtoToJSON(value['notification_properties']),
        'normal_properties': IOrganizationPropertyInfoDtoToJSON(value['normal_properties']),
        'note': IOrganizationNoteDtoToJSON(value['note']),
        'organization_path': value['organization_path'],
        'partner_external_identifier': value['partner_external_identifier'],
        'activation_started': value['activation_started'],
        'partner_name': value['partner_name'],
        'termination_date': value['termination_date'] == null ? undefined : ((value['termination_date']).toISOString()),
        'is_locked': value['is_locked'],
        'is_limited_features_during_termination_in_progress': value['is_limited_features_during_termination_in_progress'],
        'modified_overridable_properties': value['modified_overridable_properties'] == null ? undefined : ((value['modified_overridable_properties'] as Array<any>).map(IPropertyChangeDtoToJSON)),
        'has_child_organizations': value['has_child_organizations'],
        'custodian_name': value['custodian_name'],
        'custodian_agreement_url': value['custodian_agreement_url'],
        'interest_template_id': value['interest_template_id'],
    };
}

